import { assignAchievement as aA } from "src/components/Leaderboard"
import VideoModal from "src/components/VideoModal"
import { userID } from "src/utils/datalayer"
import { leaderboardOptIn, modalColor } from "../utils"
import { ModalWrapper } from "src/utils/fw"
import { dismiss } from "./modals/HTEP"
import BoothPopup from "../components/BoothPopup"

const assignAchievement = async (data) => {
    if (!leaderboardOptIn) return;

    return aA(data)
}

export default {
    background: "https://assets.swoogo.com/uploads/full/4590336-6721495cab30c.png",
    links: [
        {
            label: "SureCloud Logo",
            width: "26%",
            height: "11.7%",
            left: "10.3%",
            top: "16%",
            modalOverrides: dismiss,
            modal: <BoothPopup
                companyName="SureCloud"
                companyUrl="https://www.surecloud.com/"
                image="https://assets.swoogo.com/uploads/medium/4485105-66fc4bb53e43b.png"
                room="gold"
                text={<>
                    <p>SureCloud’s Gartner-recognised GRC platform ensures secure and compliant GRC operations through automation and seamless integration, saving you time while enhancing your risk posture. The SureCloud platform can be easily configured to fit a wide range of operating platforms without the need for coding expertise, so you get immediate and sustained value from the outset. Automate your processes, continuously mitigate risk and stay compliant – SureCloud keeps your business assured, always.
                    For more information please visit: https://www.surecloud.com/ or connect with us on LinkedIn.</p>
                </>}
                socialMedia={[
                    {name: "LinkedIn", url: "https://www.linkedin.com/company/surecloud"},
                    {name: "X/Twitter", url: "https://x.com/SureCloud"},
                    {name: "Facebook", url: "https://www.facebook.com/surecloud"},
                    {name: "YouTube", url: "https://www.youtube.com/user/SureCloudTV"},
                    {name: "Instagram", url: "https://www.instagram.com/surecloud/"}
                ]}
                socialMediaCss={{width: "56%"}}
            />
        },
        {
            label: "SureCloud Video",
            modalOverrides: dismiss,
            modal: <ModalWrapper wrapperStyle={{
                background: modalColor,
                aspectRatio: "16 / 9",
                width: "50%",
                minWidth: "700px"
            }}>
                <VideoModal url="https://player.vimeo.com/video/1024785993?h=76e4ebd514&autoplay=1" />
            </ModalWrapper>,
            onClick: () => {
                assignAchievement({
                    achievementId: "1862f32a-47ab-4342-858e-87a7a7dde84b",
                    eventId: "161759",
                    userId: userID
                })
            },
            width: "10%",
            height: "11.7%",
            left: "11.3%",
            top: "39%",
        },
        {
            label: "SureCloud Contact Us",
            href: "mailto:sales@surecloud.com",
            target: "_blank",
            isExternal: true,
            onClick: () => {
                assignAchievement({
                    achievementId: "b5bbf050-2d06-47ae-b5f7-d1d4ac66369b",
                    eventId: "161759",
                    userId: userID
                })
            },
            width: "12.5%",
            height: "15.7%",
            left: "6.3%",
            top: "66%",
        },
        {
            label: "SureCloud PDF File",
            href: "https://assets.swoogo.com/uploads/4585714-671feedb7111b.pdf",
            target: "_blank",
            onClick: () => {
                assignAchievement({
                    achievementId: "a0a64b9f-ad3c-45a8-a8d8-101a4bece229",
                    eventId: "161759",
                    userId: userID
                })
            },
            width: "5.5%",
            height: "23.7%",
            left: "43%",
            top: "57.4%",
        },
        {
            label: "SecurityScorecard Logo",
            width: "29%",
            height: "11.7%",
            left: "60.3%",
            top: "16%",
            modalOverrides: dismiss,
            modal: <BoothPopup
                companyName="SecurityScorecard"
                companyUrl="http://www.securityscorecard.com/"
                image="https://assets.swoogo.com/uploads/medium/3986520-6658129f98f42.png"
                room="gold"
                text={<>
                    <p>Funded by world-class investors, including Evolution Equity Partners, Silver Lake Partners, Sequoia Capital, GV, Riverwood Capital, and others, SecurityScorecard is the global leader in cybersecurity ratings, response, and resilience, with more than 12 million companies continuously rated. Founded in 2013 by security and risk experts Dr. Aleksandr Yampolskiy and Sam Kassoumeh, SecurityScorecard’s patented security ratings technology is used by over 25,000 organisations for enterprise risk management, third-party risk management, board reporting, due diligence, cyber insurance underwriting, and regulatory oversight. SecurityScorecard makes the world safer by transforming how companies understand, improve, and communicate cybersecurity risk to their boards, employees, and vendors. SecurityScorecard achieved the Federal Risk and Authorisation Management Program (FedRAMP) Ready designation, highlighting the company’s robust security standards to protect customer information, and is listed as a free cyber tool and service by the U.S. Cybersecurity & Infrastructure Security Agency (CISA). Every organisation has the universal right to its trusted and transparent Instant SecurityScorecard rating.
                    For more information, visit securityscorecard.com or connect with us on LinkedIn.</p>
                </>}
                socialMedia={[
                    {name: "LinkedIn", url: "https://www.linkedin.com/company/security-scorecard"},
                    {name: "X/Twitter", url: "https://twitter.com/security_score"},
                    {name: "Facebook", url: "https://www.facebook.com/SecScorecard"},
                    {name: "YouTube", url: "https://www.youtube.com/channel/UCbTCXVt5mJTV3eI5_m2chZQ"},
                    {name: "Instagram", url: "https://www.instagram.com/securityscorecard/"}
                ]}
                socialMediaCss={{width: "56%"}}
            />
        },
        {
            label: "Security Scorecard Video",
            modalOverrides: dismiss,
            modal: <ModalWrapper wrapperStyle={{
                background: modalColor,
                aspectRatio: "16 / 9",
                width: "50%",
                minWidth: "700px"
            }}>
                <VideoModal url="https://player.vimeo.com/video/1024785972?h=1a93f466da&autoplay=1" />
            </ModalWrapper>,
            onClick: () => {
                assignAchievement({
                    achievementId: "22eebfdf-b8be-4de8-90d5-8536814a4db8",
                    eventId: "161759",
                    userId: userID
                })
            },
            width: "10%",
            height: "11.7%",
            left: "78.5%",
            top: "39%",
        },
        {
            label: "Security Scorecard Contact Us",
            href: "mailto:Int-BDR@securityscorecard.io",
            onClick: () => {
                assignAchievement({
                    achievementId: "993f9e0b-db8f-4fe5-b7a3-358e345c3c1b",
                    eventId: "161759",
                    userId: userID
                })
            },
            isExternal: true,
            target: "_blank",
            width: "12.5%",
            height: "15.7%",
            left: "81.3%",
            top: "66%",
        },
        {
            label: "Security Scorecard PDF File",
            href: "https://assets.swoogo.com/uploads/4585724-671fef3f7b12d.pdf",
            onClick: () => {
                assignAchievement({
                    achievementId: "f4a354d1-ec46-43e5-aa24-403cd790592a",
                    eventId: "161759",
                    userId: userID
                })
            },
            target: "_blank",
            width: "5.5%",
            height: "23.7%",
            left: "51.6%",
            top: "57.4%",
        },
        {
            label: "Back to Exhibition Hall",
            href: "/exhibition-hall",
            width: "14.3%",
            height: "8%",
            left: "44.9%",
            top: "89.4%",
        }
    ],
    name: "exhibition-hall-gold",
}